<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="card shadow">
    <div class="card-body">
        <div class="row">
            <div class="col-12 col-md-7 row">
                <p class="col-4 pl-8 text-nowrap text-secondary" i18n>
                    Description
                </p>
                <div class="col">
                    {{ role?.description }}
                </div>
            </div>
            <div class="col-12 col-md-5 row">
                <p class="col-4 text-nowrap text-secondary" i18n>
                    Created
                </p>
                <div class="col">
                    {{ role?.createdAt | dateTime }}
                </div>
            </div>
            <div class="col-12 col-md-7 row">
                <p class="col-4 pl-8 text-nowrap text-secondary" i18n>
                    Users
                </p>
                <div class="col">
                    {{ role?.numberOfUsers }}
                </div>
            </div>
            <div class="col-12 col-md-5 row">
                <p class="col-4 text-nowrap text-secondary" i18n>
                    Edited
                </p>
                <div class="col">
                    {{ role?.updatedAt | dateTime }}
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details-card/role-details-card.component.html